import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aa21c614")

_pushScopeId("data-v-aa21c614")
const _hoisted_1 = {
  class: "scroll",
  ref: "scroll$"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_scroll_item = _resolveComponent("scroll-item")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.stripeTransform, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "scroll-stripe",
        key: index,
        style: {
        paddingTop: item.paddingTop + 'px',
        transform: `translateY(${item.top}px)`,
      }
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imgList.filter((v, k) => (k + 1) % 3 === index), (v, index) => {
          return (_openBlock(), _createBlock(_component_scroll_item, {
            class: "scroll-item",
            key: index,
            url: v.imgUrl,
            title: v.title
          }, null, 8, ["url", "title"]))
        }), 128))
      ], 4))
    }), 128))
  ], 512))
})